// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelActivities extends React.Component<Props> {
  get headlinesData() {
    return [
      {
        id: "new-updated-absences",
        label: this.props.t("NEW_UPDATED_ABSENCES"),
        details: this.props.t("ACTIVITIES_NEW_AND_UPDATED_ABSENCES"),
      },
      {
        id: "closed-absences",
        label: this.props.t("CLOSED_ABSENCES"),
        details: this.props.t("ACTIVITES_CLOSED_ABSENCES"),
      },
      {
        id: "alerts-and-reviews",
        label: this.props.t("ALERTS_REVIEWS"),
        details: this.props.t("ACTIVITIES_ALERTS_AND_REVIEWS"),
      },
      {
        id: "manager-uploads",
        label: this.props.t("MANAGER_UPLOADS"),
        details: this.props.t("ACTIVITIES_MANAGER_UPLOADS"),
      },
      {
        id: "rtw-interviews",
        label: this.props.t("TUTORIAL_RTW_INTRVIEWS"),
        details: this.props.t("ACTIVITIES_RTW_INTERVIEWS"),
      },
    ];
  }

  get resultsData() {
    return [
      {
        id: "when",
        label: this.props.t("WHEN"),
        details: this.props.t("ACTIVITIES_WHEN_DESCRIPTION"),
      },
      {
        id: "activity",
        label: this.props.t("ACTIVITY"),
        details: this.props.t("ACTIVITIES_ACTIVITY_DESCRIPTION"),
      },
      {
        id: "details",
        label: this.props.t("DETAILS"),
        details: this.props.t("ACTIVITIES_DETAILS_DESCRIPTION"),
      },
      {
        id: "view",
        label: this.props.t("VIEW"),
        details: this.props.t("ACTIVITIES_VIEW_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("ACTIVITIES_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.ACTIVITIES_INSTRUCTIONS}
            title={this.props.t("ACTIVITIES_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("HEADLINES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.headlinesData} />
        <h6 className="font-weight-bold">{this.props.t("RESULTS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.resultsData} />
      </div>
    );
  }
}

export default localize()(HelpPanelActivities);
